import React from 'react';

// Last line of defence: a render error shows a reload prompt instead of a
// blank page. Text is hard-coded in English because the i18n layer itself may
// be what failed.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
        <div className="max-w-md w-full text-center bg-white p-8 rounded-xl border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Something went wrong</h2>
          <p className="text-sm text-gray-500 mb-6">Reload the page to continue. Your saved data is safe.</p>
          <button onClick={() => window.location.reload()} className="bg-gray-900 hover:bg-gray-700 text-white h-10 px-5 rounded-lg text-sm font-medium">
            Reload
          </button>
        </div>
      </div>
    );
  }
}
